import { getValidClassNames } from "@/utils";
import { InformationBannerProps } from "./InformationBanner.interfaces";

export const InformationBanner = ({ additionalClassNames, children, text }: InformationBannerProps) => {
  return(
    <div className={getValidClassNames({
      "border border-grey-300 rounded-md bg-white p-5 flex flex-col items-start md:flex-row md:items-center shadow-xl": true,
      [String(additionalClassNames)]: Boolean(additionalClassNames)
    })}>
      <img className="mr-4 mb-4 md:mb-0" src="/images/info-icon.svg" alt="Information" />
      {text && (
        <p className="font-heading">{text}</p>
      )}
      {children}
    </div>
  )
};